<template>
  <div>
    <h5>File type specific items </h5>
    <div>
      <input-widget
        v-for="field in getCurrentFields"
        :id="`flat-file-${field.name}`"
        :model="formFromStore"
        :field="field"
      />
    </div>
  </div>
</template>

<script>
import {fileManipulationMixin} from '@/modules/FileManipulationController/file-manipulation.mixin';
import InputWidget from '@/core/components/complex-table/components/InputWidget.vue';
import InnerConfigurations
  from '@/modules/FileManipulationController/BatchList/components/AddEditBatchModalParts/InnerConfigurations.vue';
import {createNamespacedHelpers} from 'vuex';

const {
  mapState: fileManipulationMapState,
} = createNamespacedHelpers('fileManipulationController');
export default {
  name: 'FlatFile',
  mixins: [fileManipulationMixin],
  components: {
    InnerConfigurations,
    InputWidget,
  },
  props:['isBalkFlatFile','form', 'batchFile'],
  data() {
    return {
      currentFileType: 'flatFile',
      showInnerConfigurations: false,
    };
  },
  computed: {
    ...fileManipulationMapState({
      formFromStore: state => state.formFromStore,
    }),
    getCurrentFields() {
      if(this.formFromStore.batchFileType === 'flatFile') {
        return this.flatFileFieldsForBoth;
      }
      if(this.formFromStore.batchFileType === 'bulkFlatFile') {
        return {...this.flatFileFieldsForBoth, ...this.fieldsForBulk};
      }
      if(this.formFromStore.batchFileType === 'excel') {
        if(this.formFromStore.useBulkUpload) {
          return {
            ...this.fileFieldsForExcel,
            ...this.fieldsForBulk,
          };
        }
        return this.fileFieldsForExcel;
      }
      return  [];
    },
  },
  mounted() {
    this.currentFileType = this.batchFile.batchFileType;
  },
};
</script>



<style scoped lang="scss">
.inner__config--header {
  padding-block: 10px;
  display: flex;
  align-items: center;

  border-bottom: 1px solid #ccc;
  border-top: 1px solid #ccc;

  label {
    margin-bottom: 0;
  }
}
</style>